import { useEffect } from "react";

const SITE = "https://lattice-network.it";
const DEFAULT_IMG = SITE + "/og-image.png";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-page SEO: sets <title>, description, canonical and Open Graph / Twitter tags.
 * Call it near the top of a page component: useSeo({ title, description }).
 */
export function useSeo({ title, description, image, noindex } = {}) {
  useEffect(() => {
    const full = title ? `${title} | Lattice Network` : "Lattice Network — Comunicazione aziendale sovrana";
    const url = SITE + window.location.pathname;
    const img = image || DEFAULT_IMG;
    document.title = full;
    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    upsertLink("canonical", url);
    upsertMeta("property", "og:title", full);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:title", full);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);
  }, [title, description, image, noindex]);
}
